import useUser from 'hooks/useUser';
import { FC, ReactNode } from 'react';
import { IUser } from 'types/user';

interface ICheckPermissionProps {
  permission?: (user: IUser) => boolean;
  children: ReactNode;
}

const CheckPermission: FC<ICheckPermissionProps> = ({
  permission,
  children,
}) => {
  const { user } = useUser();

  return (
    <>
      {permission && typeof permission === 'function'
        ? user && permission(user) && children
        : children}
    </>
  );
};
export default CheckPermission;
